import { ReturnDisbursementRecipientCapabilityStatus } from "@redotech/cockroachdb-codegen/tables/returns/return-disbursement-recipient-capability-status";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/** Live read from Stripe; `ready` is what gates submission. */
export const getStripeRefundRecipientStatus = {
  name: "getStripeRefundRecipientStatus" as const,
  input: z.object({ draftReturnId: zExt.objectId() }),
  output: z.object({
    providerAccountId: z.string().nullable(),
    capabilityStatus: createEnum(
      ReturnDisbursementRecipientCapabilityStatus,
    ).nullable(),
    requirementsSummary: z.string().nullable(),
    ready: z.boolean(),
  }),
};
